const STATUS_TO_TEXT = {
    'new': 'New',
    'cost-research': 'Cost Research',
    'ready-for-sales': 'Ready for Sales',
    'follow-up': 'Follow-up',
    'sending-to-endcustomer': 'Sending...',
    'sent-to-endcustomer': 'Sent to Customer',
    'opened-by-customer': 'Opened by Customer',
    'endcustomer-accepted': 'Accepted by Customer',
    'endcustomer-rejected': 'Rejected by Customer',
    'lost': 'Lost',
    'completed': 'Won',
    'open': 'Open',
};

function statusToText({ opportunity }) {
    return STATUS_TO_TEXT[opportunity.status || 'new'];
}

export { statusToText };